import { useEffect, useState } from 'react';
import { FEATURES_LIST } from '../../utils/featuresOptions';
import Checkbox from '../Checkbox';
import Button from '../Button';
import { ButtonType, ModalWindowTypes } from '../../utils/@globalTypes';
import { SelectState } from '../../redux/types/bookingTypes';
import { CloseIcon } from '../../assets/icons';
import { useDispatch, useSelector } from 'react-redux';
import { setModalWindowData } from '../../redux/reducers/pageSlice';
import {
  FeatureType,
  UpdateRentalObjectData,
} from '../../redux/types/rentalObjectTypes';
import {
  RentalObjectSelectors,
  updateRentalObjectAllBasicSettings,
} from '../../redux/reducers/rentalObjectSlice';

import styles from './FeaturesList.module.scss';

type FeaturesListType = {
  list: SelectState[];
  setList: React.Dispatch<React.SetStateAction<SelectState[]>>;
};

const FeaturesList = ({ list, setList }: FeaturesListType) => {
  const dispatch = useDispatch();

  const currentRentalObject = useSelector(
    RentalObjectSelectors.getCurrentRentalObject,
  );

  const currentList = [...FEATURES_LIST];
  const [currentSelect, setCurrentSelect] = useState<SelectState[]>(list);
  const [isChanged, setIsChanged] = useState<boolean>(false);

  const handlerSelect = (id: string) => {
    //   обработка чекбоксов в списке объектов
    const current = list.findIndex((item) => item.id === id);

    if (current > -1) {
      setCurrentSelect((prevState) => {
        const newSelect = [...prevState];
        newSelect[current] = {
          ...newSelect[current],
          checked: !newSelect[current].checked,
        };
        return newSelect;
      });
    }
  };

  function arraysAreEqual(arr1: SelectState[], arr2: SelectState[]): boolean {
    if (arr1.length !== arr2.length) return false;

    // Создаем карты для быстрого поиска элементов по id
    const map1 = new Map<string, boolean>();
    const map2 = new Map<string, boolean>();

    for (const item of arr1) {
      map1.set(item.id, item.checked);
    }

    for (const item of arr2) {
      map2.set(item.id, item.checked);
    }

    // Проверяем совпадение по каждому ключу
    for (const [id, checked] of map1) {
      if (map2.get(id) !== checked) {
        return false;
      }
    }

    return true;
  }

  useEffect(() => {
    if (!arraysAreEqual(list, currentSelect)) {
      setIsChanged(true);
    } else {
      setIsChanged(false);
    }
  }, [currentSelect]);

  const handlerSave = () => {
    setList(currentSelect);

    if (isChanged && currentRentalObject?.id) {
      const newFeatures = currentSelect.filter((feat) => feat.checked === true);
      const newFeaturesList: FeatureType[] = newFeatures.map((item) => ({
        name: '',
        logo: item.id,
      }));
      const data: UpdateRentalObjectData = {};
      data.features = newFeaturesList;
      dispatch(
        updateRentalObjectAllBasicSettings({
          info: Object.keys(data).length
            ? {
                id: +currentRentalObject?.id,
                data,
              }
            : undefined,
        }),
      );
      dispatch(
        setModalWindowData({
          type: ModalWindowTypes.CLOSE,
        }),
      );
    }
  };
  const handlerClose = () => {
    dispatch(
      setModalWindowData({
        type: ModalWindowTypes.CLOSE,
      }),
    );
  };

  const handlerDeleteAll = () => {
    const emptySelect: SelectState[] = [];
    currentSelect.forEach((item) => {
      emptySelect.push({ id: item.id, checked: false });
    });
    setCurrentSelect(emptySelect);
  };

  const features = currentList.map((item) => {
    const localState = item.list.map((feat) => {
      const index =
        currentSelect.length > 0
          ? currentSelect.findIndex((listFeat) => listFeat.id === feat.logo)
          : -1;
      const isChecked = currentSelect[index].checked;

      return (
        <div className={styles.item_wrap} key={feat.logo}>
          <Checkbox
            checked={isChecked}
            label={feat.label}
            name={feat.logo}
            onClick={() => handlerSelect(feat.logo)}
            className="featureBox"
          />
          <span className={styles.feat_title}>{feat.title}</span>
        </div>
      );
    });

    return (
      <div key={item.feature_header}>
        <h3 className={styles.header}>{item.feature_header}</h3>
        <div className={styles.block_wrap}>{localState}</div>
      </div>
    );
  });

  return (
    <div className={styles.container}>
      <div className={styles.block_header}>
        <div className={styles.header_title}>
          Выбор удобств сдаваемого объекта
        </div>
        <div className={styles.close} onClick={handlerClose}>
          <CloseIcon />
        </div>
      </div>
      {features}
      <div className={styles.btn_wrap}>
        <Button
          title="Сохранить"
          type={ButtonType.PRIMARY_SMALL}
          onClick={handlerSave}
          disabled={!isChanged}
        />
        <Button
          title="Очистить всё"
          type={ButtonType.SECONDARY_SMALL}
          onClick={handlerDeleteAll}
        />
        <Button
          title="Отмена"
          type={ButtonType.SECONDARY_SMALL}
          onClick={handlerClose}
        />
      </div>
    </div>
  );
};

export default FeaturesList;
